import Splide from '@splidejs/splide';

$(function() {
    
	/**
	 * toggle meny
	 */
    $('.hamburger-icon').click(function () {
        $(this).toggleClass('open');
        if ($(this).hasClass('open'))
            $(".menu").slideDown();
        else
            $(".menu").slideUp();
    });

    function closeMenu() {
        var $hamburger = $('.hamburger-icon');
        if ($hamburger.hasClass("open")) {
            $hamburger.removeClass("open");
            $(".menu").slideUp();
        }
    }

	/**
	 * scroll to companies if sub-domains
	 */
    if (location.href.indexOf("#") == -1) {
        if (location.href == "http://flow-elektro.no/" ||
            location.href == "http://flow-klima.no/" ||
            location.href == "http://flow-vvs.no/") {
            var anchor = $("a[name='selskaper']");
            if (anchor.length) {
                closeMenu();

                var headerHeight = $("header").height() + 40;
                var scrollTop = anchor.offset().top - headerHeight;
                window.setTimeout(function () {
                    $('html, body').scrollTop(scrollTop);
                }, 10);
            }
        }
    }

	/**
	 * on IE, position blue line by setting height
	 */
    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
        function resizeLines() {
            // 1600 / 144
            var width = $(".featured--home").width();
            var height = parseInt(width * 0.09);
            $(".featured-line").css("height", height)
        }
        $(window).on("resize", resizeLines);
        resizeLines();
    }

	/**
	 * internal links
	 */
    $("body").on("click", "a", function (e) {
        var href = $(this).attr('href');
        if (href && href.length && href[0] == "#") {
            e.preventDefault();

            if (href.length > 1) {
                var anchor = $("a[name='" + href.substr(1) + "']");
                if (anchor.length) {
                    closeMenu();

                    var headerHeight = $("header").height() + 40;
                    $('html, body').animate({ scrollTop: anchor.offset().top - headerHeight });
                }
                return false;
            }
        }
    });

	/**
	 * submenu
	 */
    $(".submenu li").on("mouseover hover", function (e) {

        if (!$(this).hasClass("active")) {
            var index = $(this).index();
            $(this).closest(".submenu").find("li.active").removeClass("active");
            $(this).addClass("active");

            var $submenuItems = $(this).closest(".submenu").nextAll(".submenu-items");
            $submenuItems.children().hide().eq(index).show();
        }
    });

    $(".btn-readmore-body").click(function (e) {
        e.preventDefault();
        $(this).fadeOut(250, function () {
            $(this).next().slideDown(500, function () {
                $(this).closest(".text-container").next(".submenu").show().next().show();
            });
        });
    });


    if($('.splide').length) {
        Splide.defaults = {
            type : 'loop',
            speed : 1000,
            autoplay : true,
            intervall : 5000
        };
        new Splide('.splide').mount();


        $(".splide__slide img").on("click", function() {
            var link = $(this).parent().find("a").attr("href");
            if(link) {
                window.location = link;   
            }
        });
    }

    $('.featured-video-play').click(function() {
        $(this).hide().parent().find("video").attr("controls", true)[0].play();
    });

});